import { useThemeDetector } from "@/hooks/useThemeDetector";

interface WalmartLogoProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export default function WalmartLogo({ width = "auto", height = "auto", className = "" }: WalmartLogoProps) {
  const isDarkTheme = useThemeDetector();

  // Use the appropriate image based on theme
  const imageSrc = 
    "/images/walmart.svg";
  return (
    <img 
      src={imageSrc} 
      width={width} 
      height={height} 
      className={className}
      alt="Walmart"
    />
  );
}